import { Button, Checkbox, DatePicker, Form } from "antd";
import { useContext, useEffect, useState } from "react";
import Moment from "react-moment";
import moment from "moment";
import logo from "../../../assets/images/logo-icon.png";
import { BsCalendar4Event } from "react-icons/bs";
import { IoIosLogIn } from "react-icons/io";
import Toastify from "toastify-js";
import { Link } from "react-router-dom";
import fetchDataTrace from "../../../services/fetchDataTrace";
import { AuthContext } from "../../../contexts/AuthContext";
import { pusher } from "../../..";
import { RiFilterOffLine } from "react-icons/ri";
import WallVisits from "./components/WallVisits";
import { useQuery } from "@tanstack/react-query";
import { handleFetchWallVisits } from "../../../api/visits";
import WallBookings from "./components/WallBookings";

const { RangePicker } = DatePicker;
export default function WallPage() {
  const { user, token, expire } = useContext(AuthContext);

  const [bookings, setBookings] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [showRange, setShowRange] = useState(false);

  const start = moment(new Date()).format("YYYYMMDD");
  const end = moment(new Date()).format("YYYYMMDD");
  const [startDate, setStateDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [isBooking, setBooking] = useState<boolean>(false);

  const [form] = Form.useForm();

  const [dates, setDates] = useState<any>({
    startDate: moment(new Date()).format("YYYYMMDD"),
    endDate: moment(new Date()).format("YYYYMMDD"),
    isRange: false,
  });

  const site = user?.site?._id || "6224dcf60c5c49d9fec9218f";

  const {
    data: visits,
    refetch: refetchVisits,
    isLoading: visitLoading,
  } = useQuery({
    queryKey: ["visits", site],
    queryFn: () => handleFetchWallVisits({ site }),
  });

  const handleFetchData = async ({ dates }: any) => {
    setLoading(true);
    const uri = `bookings/wall/${site}?start=${dates?.startDate}&end=${dates?.endDate}`;
    const response = await fetchDataTrace({
      uri,
      token,
      expire,
    });
    if (response?.success) {
      setBookings(response?.payload);
    }
    setLoading(false);
  };

  const handleFetchBookings = async () => {
    setLoading(true);
    const uri = `bookings/wall/${
      site || "6224dcf60c5c49d9fec9218f"
    }?start=${startDate}&end=${endDate}`;
    const data = await fetchDataTrace({ uri, token, expire });
    setBookings(data?.payload);
    setLoading(false);
  };

  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
    setDates({
      startDate: moment(new Date(date)).format("YYYYMMDD"),
      endDate: moment(new Date(date)).format("YYYYMMDD"),
      isRange: false,
    });

    handleFetchData({
      dates: {
        startDate: moment(new Date(date)).format("YYYYMMDD"),
        endDate: moment(new Date(date)).format("YYYYMMDD"),
        isRange: false,
      },
    });
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
    setDates({
      startDate: moment(new Date(date[0])).format("YYYYMMDD"),
      endDate: moment(new Date(date[1])).format("YYYYMMDD"),
      isRange: true,
    });

    handleFetchData({
      dates: {
        startDate: moment(new Date(date[0])).format("YYYYMMDD"),
        endDate: moment(new Date(date[1])).format("YYYYMMDD"),
        isRange: true,
      },
    });
  };

  const clearDate = () => {
    form.resetFields();
    const start = moment().startOf("isoWeek").format("YYYYMMDD");
    const end = moment().endOf("isoWeek").format("YYYYMMDD");
    setStateDate(start);
    setEndDate(end);
    setDates({
      startDate: moment(new Date()).format("YYYYMMDD"),
      endDate: moment(new Date()).format("YYYYMMDD"),
      isRange: false,
    });
    handleFetchData({
      dates: {
        startDate: moment(new Date()).format("YYYYMMDD"),
        endDate: moment(new Date()).format("YYYYMMDD"),
        isRange: false,
      },
    });
  };

  useEffect(() => {
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      handleFetchBookings();

      Toastify({
        text: `New Booking Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    book.bind("confirm", function (data: any) {
      handleFetchBookings();
    });

    return () => {
      pusher.unsubscribe("booking");
    };
  }, []);

  useEffect(() => {
    handleFetchData({ dates });
  }, [dates]);

  useEffect(() => {
    const scan = pusher.subscribe(`visit`);
    scan.bind("in", function (data: any) {
      refetchVisits();
      Toastify({
        text: `${data?.payload?.vehicle || "-"}`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    scan.bind("out", function (data: any) {
      refetchVisits();
      Toastify({
        text: `${data?.payload?.vehicle || "-"}`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "red",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    return () => {
      pusher.unsubscribe("visit");
    };
  }, [site]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setBooking(!isBooking);
  //   }, 5000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [isBooking]);

  return (
    <>
      <div className="h-16 bg-toyota flex items-center justify-between px-2">
        <div className="flex items-center font-bold">
          <div className="">
            <img src={logo} alt="" width={52} />
          </div>
          <div className="mx-2 text-white text-xl w-28">
            {isBooking ? "BOOKINGS" : "LOCATIONS"}
          </div>
          <div className="flex justify-center items-center text-white mb-1 mr-1">
            :
          </div>

          <div className=" text-white text-xl uppercase">
            {dates?.isRange ? (
              <div className="">
                <Moment format={"Do MMMM YYYY"}>{dates?.startDate}</Moment>
                <span className="px-2">-</span>
                <Moment format={"Do MMMM YYYY"}>{dates?.endDate}</Moment>
              </div>
            ) : (
              <div className="">
                <Moment format={"Do MMMM YYYY"}>{dates?.startDate}</Moment>
              </div>
            )}
          </div>
        </div>
        <div className="-ml-44">
          {isBooking ? (
            <div className="flex">
              <div className="flex flex-col justify-center items-center border-r">
                <button className="w-20 p-1 rounded-lg text-white mr-1 flex justify-center items-center font-bold">
                  Bookings
                </button>
                <div className="h-2 w-6 bg-white rounded-2xl"></div>
              </div>
              <div className="flex flex-col justify-center items-center pl-1">
                <button
                  onClick={() => setBooking(false)}
                  className="w-20 p-1 rounded-lg text-white mr-1 flex justify-center items-center font-bold"
                >
                  Locations
                </button>
                <div className="h-2 w-6 bg-toyota rounded-2xl"></div>
              </div>
            </div>
          ) : (
            <div className="flex">
              <div className="flex flex-col justify-center items-center border-r">
                <button
                  onClick={() => setBooking(true)}
                  className="w-20 p-1 rounded-lg text-white mr-1 flex justify-center items-center font-bold"
                >
                  Bookings
                </button>
                <div className="h-2 w-6 bg-toyota rounded-2xl"></div>
              </div>
              <div className="flex flex-col justify-center items-center pl-1">
                <button className="w-20 p-1 rounded-lg text-white mr-1 flex justify-center items-center font-bold">
                  Locations
                </button>
                <div className="h-2 w-6 bg-white rounded-2xl"></div>
              </div>
            </div>
          )}
        </div>
        <div className="flex items-center font-bold">
          <div className="mr-2 text-white pb-1">
            {user?.site?.name || "Toyota HQ ( Dar es salaam )"}
          </div>
          <Link to="/">
            <IoIosLogIn size={30} color="#FFFFFF" />
          </Link>
        </div>
      </div>
      <div className="bg-gray-50 border-b border-gray-300 px-2 py-1 flex items-center justify-between">
        <Form layout="inline" form={form}>
          {showRange ? (
            <div className="flex justify-center items-center">
              <Form.Item name="ranger">
                <RangePicker
                  allowClear={true}
                  onChange={onRangeChange}
                  format={"DD-MM-YYYY"}
                />
              </Form.Item>

              <Checkbox onChange={() => setShowRange(!showRange)}>
                <span className="text-gray-500">Date as Range</span>
              </Checkbox>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <Form.Item name="picker">
                <DatePicker
                  onChange={onDateChange}
                  format={"DD-MM-YYYY"}
                  placeholder="Specific date"
                  className=" border-gray-300"
                />
              </Form.Item>
              <Checkbox onChange={() => setShowRange(!showRange)}>
                <span className="text-gray-500">Date as Range</span>
              </Checkbox>
            </div>
          )}
          <Button className="" onClick={() => clearDate()}>
            <RiFilterOffLine color="#6b7280" />
          </Button>
        </Form>
        <Link to="/bookings/calendar" className="">
          <BsCalendar4Event color={"#323232"} size={20} />
        </Link>
      </div>

      <div className="flex flex-col rounded-lg bg-gray-100 ">
        <div className="grid gap-x-0 grid-cols-12">
          <div className="col-span-12 sm:col-span-12 md:col-span-12">
            {isBooking ? (
              <WallBookings bookings={bookings} isLoading={isLoading} />
            ) : (
              <WallVisits
                visits={visits?.payload || []}
                isLoading={visitLoading}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
